import Character from './character';

export default Character;
export { toCharacters } from './to-characters';
